// 拍搜结果分享页
import Page from '../Page';
import Index from './index.vue';

/* eslint-disable no-new */
new Page({
  title: '快对AI智能解题又快又准',
  component: Index
});
